import { AxiosResponse } from 'axios';
import { ActValueDomainResponseVM } from 'civil-status/view-models/act-value-domain-managment-list';
import { DateTime } from 'luxon';
import { NewHttpResponseList } from 'shell/models/http-response';
import { ValueDomainType } from 'shell/models/value-domain-type';

export const transformActDomainTypeValues = (
  response: AxiosResponse<NewHttpResponseList<ValueDomainType>>
): ActValueDomainResponseVM => {
  const data = response.data.payload || [];
  const pageInfo = response.data?.pageInfo;
  if (pageInfo) {
    pageInfo.page = pageInfo.page / pageInfo.pageSize;
  }

  const res: ActValueDomainResponseVM = {
    pageInfo,
    valuesDomain: data?.map((item: ValueDomainType) => ({
      valueAnsc: item?.idValoreAnsc || '',
      value: item?.key?.idValore || '',
      startValidityDate: item?.dataInizioValidita
        ? DateTime.fromISO(item?.dataInizioValidita || '').toFormat('dd/MM/yyyy')
        : '',
      endValidityDate: item?.dataFineValidita
        ? DateTime.fromISO(item?.dataFineValidita || '').toFormat('dd/MM/yyyy')
        : '',
      description: item?.valore || '',
      orderNumber: item?.numOrdinamento?.toString() || '',
      displayOrderNumber: item?.numOrdinamento?.toString() || '',
      shortDescription: item?.descrizioneBreveValore || '',
      precedingArticle: item?.descrizioneArticoloAnteposto || '',
      type: item?.codiceGenere || '',
      statisticCode: item?.codiceStatistico || '',
      lawAuthorizeArticle: item?.autorizzazioneArticoloLegge || '',
      fatherDomainType: item?.tipoDominioPadre?.toString() || '',
      domainType: item?.key?.idDominio?.toString() || '',
      fatherDomainValue: item?.idValorePadre || '',
      entityBody: item?.key?.codEnte || '',
    })),
  };

  return res;
};
